import styled from 'styled-components';
import {Link} from "react-router-dom";
import { DropdownListItem } from "@brg/ui";

export const NeutralLink = styled(Link)`
  width: 100%;
  display: flex;
  align-items: center;
  color: inherit;
  :hover {
    color: inherit;
  }
  ${DropdownListItem} {
    width: 100%;
  }
`;

export const NeutralLinkBasic = styled.a`
  color: inherit;
  :hover {
    color: inherit;
  }
`;
import styled from 'styled-components';
import {Link} from "react-router-dom";
import { DropdownListItem } from "@brg/ui";

export const NeutralLink = styled(Link)`
  width: 100%;
  display: flex;
  align-items: center;
  color: inherit;
  :hover {
    color: inherit;
  }
  ${DropdownListItem} {
    width: 100%;
  }
`;

export const NeutralLinkBasic = styled.a`
  color: inherit;
  :hover {
    color: inherit;
  }
`;
